import { getAuthAxiosBackend } from "@/helpers/axios"

class PlaceAffiliationsServices {
    get(id) {
        return getAuthAxiosBackend().get('PlaceAffiliations/getPlaceAffiliationsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('PlaceAffiliations/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('PlaceAffiliations/addPlaceAffiliations', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('PlaceAffiliations/updatePlaceAffiliations/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('PlaceAffiliations/restorePlaceAffiliations' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('PlaceAffiliations/softDeletePlaceAffiliations/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('PlaceAffiliations/deletePlaceAffiliations/' + id.toString())
    }
}

export default new PlaceAffiliationsServices()
